(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4947],{

/***/ 10502:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/warning.42d8cafb.svg","height":20,"width":20});

/***/ }),

/***/ 58886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72433);

const usePdpi18n = function(authorData) {
    let badgeText = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", name = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", productBrandName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)();
    var _listpricelabel, _colorlabel, ref, _professionalService, _installationHelp, _installerArea, _maxProducts, ref1, _superskulabel, _priceFootnoteTitle, _priceFootnote, _colorFootnoteTitle, _colorFootnote, _discontinueProductMsg, _discontinueColorMsg, _onPdpCtaLabel, _colorOrFinish, _outofStockTitle, _welcomeMsg, _notifyEmailTxt, _findLocalStore, _backOrder, _specialOrder, _discontinueColorLabel, _discontinueColorFinishLabel, _modalRightSectionTitle, _modalRightSectionDesc, _modalRighttSectionCtaLabel, _modalLeftSectionTitle, _onPdpTooltip, _priceSpiderTitle, _oversizeMsgTitle, _oversizeMsgDesc, _noPriceMsg, _listpricetooltip, _subCopy, _subCopy1, _serviceavailable, _errorMessage, _zipcodevalidationmessage, _zipcodevalidationmessage1, ref2, ref3, _shippingTitle, _shippingDescription, _modalRightSectionNoStockMsg;
    const i18n = {
        home: t("kf.global.label.home"),
        viewLink: t("kf.pdp.label.viewGallery"),
        linkMore: t("kf.pdp.label.morePhotos"),
        moreCollection: t("kf.pdp.label.moreFromCollection"),
        moreCollectionDiscontinued: t("kf.pdp.label.moreFromCollectionDiscontinued"),
        shopText: t("kf.pdp.label.shopAll"),
        listPrice: t("kf.pdp.label.listPrice"),
        refPrice: (_listpricelabel = authorData.listpricelabel) !== null && _listpricelabel !== void 0 ? _listpricelabel : t("kf.pdp.label.refPrice"),
        startingAt: t("kf.pdp.label.startingAt"),
        finish: (_colorlabel = authorData.colorlabel) !== null && _colorlabel !== void 0 ? _colorlabel : t("kf.pdp.label.finish"),
        orderSample: t("kf.pdp.label.orderSample"),
        dimensions: t("kf.pdp.label.dimensions"),
        details: t("kf.pdp.label.details"),
        viewAllSpecs: t("kf.pdp.label.viewAllSpecs"),
        viewMore: t("kf.pdp.label.viewMore"),
        viewGallery: (ref = authorData === null || authorData === void 0 ? void 0 : authorData.viewgalleryctalabel) !== null && ref !== void 0 ? ref : t("kf.pdp.label.viewGallery"),
        length: t("kf.pdp.label.length"),
        width: t("kf.pdp.label.width"),
        height: t("kf.pdp.label.height"),
        smLength: t("kf.pdp.label.smLength"),
        smWidth: t("kf.pdp.label.smWidth"),
        smHeight: t("kf.pdp.label.smHeight"),
        learnMore: t("kf.pdp.label.learnMore"),
        addToCart: t("kf.cart.label.addToCart"),
        addService: t("kf.cart.label.addService"),
        print: t("kf.plp.label.print"),
        wishlist: t("kf.pdp.label.wishlist"),
        share: t("kf.plp.label.share"),
        addToCompare: t("kf.compare.label.addToCompare"),
        nearByStoreLink: t("kf.pdp.label.nearByStoreLink"),
        professionalService: (_professionalService = authorData.professionalService) !== null && _professionalService !== void 0 ? _professionalService : t("kf.pdp.label.professionalService"),
        installationHelp: (_installationHelp = authorData.installationHelp) !== null && _installationHelp !== void 0 ? _installationHelp : t("kf.pdp.label.installationHelp"),
        installerArea: (_installerArea = authorData.installerArea) !== null && _installerArea !== void 0 ? _installerArea : t("kf.pdp.label.installerArea"),
        sameCategory: t("kf.compare.validation.sameCategory"),
        maxProduct: (_maxProducts = authorData.maxProducts) !== null && _maxProducts !== void 0 ? _maxProducts : t("kf.compare.validation.maxProducts"),
        sameVariants: (ref1 = authorData === null || authorData === void 0 ? void 0 : authorData.sameVariants) !== null && ref1 !== void 0 ? ref1 : t("kf.compare.validation.sameVariants"),
        itemAdded: t("kf.pdp.label.itemAdded"),
        itemsAdded: t("kf.pdp.label.itemsAdded"),
        yourCart: t("kf.pdp.label.yourCart"),
        updateItemsErrorMsg: "kf.cart.label.updateItemsErrorMsg",
        selectMoreOptions: t("kf.pdp.label.selectMoreOptions"),
        productOptions: (_superskulabel = authorData.superskulabel) !== null && _superskulabel !== void 0 ? _superskulabel : t("kf.pdp.label.productOptions"),
        priceFootnoteTitle: (_priceFootnoteTitle = authorData.priceFootnoteTitle) !== null && _priceFootnoteTitle !== void 0 ? _priceFootnoteTitle : t("kf.pdp.label.priceFootnoteTitle"),
        priceFootnote: (_priceFootnote = authorData.priceFootnote) !== null && _priceFootnote !== void 0 ? _priceFootnote : t("kf.pdp.label.priceFootnote"),
        colorFootnoteTitle: (_colorFootnoteTitle = authorData.colorFootnoteTitle) !== null && _colorFootnoteTitle !== void 0 ? _colorFootnoteTitle : t("kf.pdp.label.colorFootnoteTitle"),
        colorFootnote: (_colorFootnote = authorData.colorFootnote) !== null && _colorFootnote !== void 0 ? _colorFootnote : t("kf.pdp.label.colorFootnote"),
        discontinueProductMsg: (_discontinueProductMsg = authorData.discontinueProductMsg) !== null && _discontinueProductMsg !== void 0 ? _discontinueProductMsg : t("kf.pdp.label.discontinueProductMsg"),
        discontinueColorMsg: (_discontinueColorMsg = authorData.discontinueColorMsg) !== null && _discontinueColorMsg !== void 0 ? _discontinueColorMsg : t("kf.pdp.label.discontinueColorMsg"),
        itemReqCTA: (_onPdpCtaLabel = authorData.onPdpCtaLabel) !== null && _onPdpCtaLabel !== void 0 ? _onPdpCtaLabel : t("kf.pdp.label.itemReqCTA"),
        editItemReqCTA: authorData.onPdpCtaLabel ? "".concat(t("kf.pdp.label.edit"), " ").concat(authorData.onPdpCtaLabel) : t("kf.pdp.label.editItemReqCTA"),
        colorOrFinish: (_colorOrFinish = authorData.colorOrFinish) !== null && _colorOrFinish !== void 0 ? _colorOrFinish : t("kf.pdp.label.colorOrFinish"),
        outOfStockMsg: authorData.outofStockDesc,
        outOfStock: (_outofStockTitle = authorData.outofStockTitle) !== null && _outofStockTitle !== void 0 ? _outofStockTitle : t("kf.pdp.label.outOfStockMsg"),
        notifyMailCTA: t("kf.pdp.label.notifyMailCTA"),
        emailAddress: t("kf.pdp.label.emailAddress"),
        validEmail: t("kf.pdp.label.validEmail"),
        welcomeMsg: (_welcomeMsg = authorData.welcomeMsg) !== null && _welcomeMsg !== void 0 ? _welcomeMsg : t("kf.pdp.label.welcomeMsg"),
        discontinuedTxt: t("kf.pdp.label.discontinuedTxt"),
        compareTxt: t("kf.pdp.label.compareTxt"),
        favTxt: t("kf.pdp.label.favTxt"),
        projectTxt: t("kf.pdp.label.projectTxt"),
        findItemCTA: t("kf.pdp.label.findItemCTA"),
        availColorCTA: authorData.discontinuePartialCtaLabel ? authorData.discontinuePartialCtaLabel : t("kf.pdp.label.availColorCTA"),
        notifyEmailTxt: (_notifyEmailTxt = authorData.notifyEmailTxt) !== null && _notifyEmailTxt !== void 0 ? _notifyEmailTxt : t("kf.pdp.label.notifyEmailTxt"),
        findLocalStore: (_findLocalStore = authorData.findLocalStore) !== null && _findLocalStore !== void 0 ? _findLocalStore : t("kf.pdp.label.findLocalStore"),
        toCheckAvailability: t("kf.pdp.label.toCheckAvailability"),
        backOrder: (_backOrder = authorData.backOrder) !== null && _backOrder !== void 0 ? _backOrder : t("kf.pdp.label.backOrder"),
        specialOrder: (_specialOrder = authorData.specialOrder) !== null && _specialOrder !== void 0 ? _specialOrder : t("kf.pdp.label.specialOrder"),
        discontinuedColor: (_discontinueColorLabel = authorData.discontinueColorLabel) !== null && _discontinueColorLabel !== void 0 ? _discontinueColorLabel : t("kf.pdp.label.discontinuedColor"),
        discontinuedColorFinish: (_discontinueColorFinishLabel = authorData.discontinueColorFinishLabel) !== null && _discontinueColorFinishLabel !== void 0 ? _discontinueColorFinishLabel : t("kf.pdp.label.discontinuedColorFinish"),
        toolTip: t("kf.pdp.label.toolTip"),
        requiredProductTitle: (_modalRightSectionTitle = authorData.modalRightSectionTitle) !== null && _modalRightSectionTitle !== void 0 ? _modalRightSectionTitle : t("kf.pdp.label.requiredProductTitle"),
        requiredProductDescription: (_modalRightSectionDesc = authorData.modalRightSectionDesc) !== null && _modalRightSectionDesc !== void 0 ? _modalRightSectionDesc : t("kf.pdp.label.requiredProductDescription"),
        productText: t("kf.pdp.label.productText"),
        includesText: t("kf.pdp.label.includesText"),
        updateText: t("kf.pdp.label.updateText"),
        includeTextCTA: (_modalRighttSectionCtaLabel = authorData.modalRighttSectionCtaLabel) !== null && _modalRighttSectionCtaLabel !== void 0 ? _modalRighttSectionCtaLabel : t("kf.pdp.label.includeTextCTA"),
        title: (_modalLeftSectionTitle = authorData.modalLeftSectionTitle) !== null && _modalLeftSectionTitle !== void 0 ? _modalLeftSectionTitle : t("kf.pdp.label.title"),
        remove: t("kf.pdp.label.remove"),
        tooltipMsg: (_onPdpTooltip = authorData.onPdpTooltip) !== null && _onPdpTooltip !== void 0 ? _onPdpTooltip : t("kf.pdp.label.tooltipMsg"),
        priceSpiderTitle: (_priceSpiderTitle = authorData.priceSpiderTitle) !== null && _priceSpiderTitle !== void 0 ? _priceSpiderTitle : t("kf.pdp.label.priceSpiderTitle"),
        primaryTxt: (_oversizeMsgTitle = authorData.oversizeMsgTitle) !== null && _oversizeMsgTitle !== void 0 ? _oversizeMsgTitle : t("kf.pdp.label.alert.primaryMsg"),
        secondaryTxt: (_oversizeMsgDesc = authorData.oversizeMsgDesc) !== null && _oversizeMsgDesc !== void 0 ? _oversizeMsgDesc : t("kf.pdp.label.alert.secondaryMsg"),
        withoutPriceTxt: (_noPriceMsg = authorData.noPriceMsg) !== null && _noPriceMsg !== void 0 ? _noPriceMsg : t("kf.pdp.label.withoutPriceTxt"),
        projectPackMssg: authorData.projectPackMssg ? authorData.projectPackMssg : t("kf.pdp.label.projectPackMssg"),
        qtyMoreThanStock: t("kf.pdp.label.qtyMoreThanStock"),
        associatePrice: t("kf.pdp.label.associatePrice"),
        friendsFamilyPrice: t("kf.pdp.label.friendsFamilyPrice"),
        listPriceInfo: (_listpricetooltip = authorData.listpricetooltip) !== null && _listpricetooltip !== void 0 ? _listpricetooltip : t("kf.pdp.label.listPriceInfo"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error"),
        installationTitle: t("kf.pdp.label.installationTitle"),
        nearestService: (_subCopy = authorData.subCopy) !== null && _subCopy !== void 0 ? _subCopy : t("kf.pdp.label.nearestService"),
        nearestInPerson: (_subCopy1 = authorData.subCopy) !== null && _subCopy1 !== void 0 ? _subCopy1 : t("kf.pdp.label.nearestInPerson"),
        edit: t("kf.pdp.label.edit"),
        change: t("kf.pdp.label.change"),
        eligibleZipCodeSuccess: (_serviceavailable = authorData.serviceavailable) !== null && _serviceavailable !== void 0 ? _serviceavailable : t("kf.pdp.label.eligibleZipCodeSuccess"),
        eligibleZipCodeError: (_errorMessage = authorData.errorMessage) !== null && _errorMessage !== void 0 ? _errorMessage : t("kf.pdp.label.eligibleZipCodeError"),
        findaPro: t("kf.pdp.label.findaPro"),
        zipcode: t("kf.pdp.label.zipcode"),
        checkAvailability: t("kf.pdp.label.checkAvailability"),
        zipCodeGuidText: t("kf.pdp.label.zipCodeGuidText"),
        update: t("kf.pdp.label.updateBtn"),
        search: t("kf.pdp.label.searchBtn"),
        forText: t("kf.pdp.label.forText"),
        memberShipPrice: t("kf.pdp.label.memberShipPrice"),
        bathroomDesignService: t("kf.pdp.label.bathroomDesignService"),
        maxInventory: t("kf.pdp.label.maxInventory"),
        zipcodeEmptyError: (_zipcodevalidationmessage = authorData.zipcodevalidationmessage) !== null && _zipcodevalidationmessage !== void 0 ? _zipcodevalidationmessage : t("kf.pdp.label.zipcodeEmptyError"),
        validZipcode: (_zipcodevalidationmessage1 = authorData.zipcodevalidationmessage) !== null && _zipcodevalidationmessage1 !== void 0 ? _zipcodevalidationmessage1 : t("kf.pdp.label.validZipcode"),
        percentOff: t("kf.pdp.label.percentOff"),
        serviceItemAdded: t("kf.pdp.label.serviceItemAdded"),
        serviceItemsAdded: t("kf.pdp.label.serviceItemsAdded"),
        serviceParts: t("kf.technical.label.serviceParts"),
        outOfStockError: authorData.invalidEmailMessage ? authorData.invalidEmailMessage : t("kf.pdp.error.outOfStock"),
        successTxt: t("kf.pdp.outOfStock.successTxt"),
        successMsg: authorData.outofStockConfirmMsg ? authorData.outofStockConfirmMsg : t("kf.pdp.outOfStock.thankMsg"),
        doneCTA: t("kf.pdp.outOfStock.doneCTA"),
        new: (ref2 = badgeText === null || badgeText === void 0 ? void 0 : badgeText.new) !== null && ref2 !== void 0 ? ref2 : t("kf.plp.label.new"),
        sale: (ref3 = badgeText === null || badgeText === void 0 ? void 0 : badgeText.onSale) !== null && ref3 !== void 0 ? ref3 : t("kf.plp.label.onSale"),
        exclusive: t("kf.plp.label.exclusive"),
        newExclusive: t("kf.plp.label.newExclusive"),
        discontinued: (badgeText === null || badgeText === void 0 ? void 0 : badgeText.discontinued) ? badgeText === null || badgeText === void 0 ? void 0 : badgeText.discontinued : t("kf.plp.label.discontinued"),
        shippingTitle: (_shippingTitle = authorData.shippingTitle) !== null && _shippingTitle !== void 0 ? _shippingTitle : t("kf.pdp.label.alert.shippingRestrictions"),
        shippingDescription: (_shippingDescription = authorData.shippingDescription) !== null && _shippingDescription !== void 0 ? _shippingDescription : t("kf.pdp.label.alert.shippingRestrictionsDesc"),
        ariaLabel: {
            serviceAddToCart: t("kf.pdp.aria.label.addServiceToCart"),
            serviceLearnMore: t("kf.pdp.aria.label.serviceLearnMore"),
            designServiceAddToCart: t("kf.pdp.aria.label.addDesignServiceToCart"),
            designServiceLearnMore: t("kf.pdp.aria.label.designServiceLearnMore"),
            addProductToCart: t("kf.pdp.aria.label.addProductToCart", {
                name
            }),
            addProductService: t("kf.pdp.aria.label.addProductService", {
                name
            }),
            print: t("kf.pdp.label.aria.print", {
                productName: name
            }),
            share: t("kf.pdp.label.aria.share", {
                productName: name
            }),
            currentPage: t("kf.pdp.label.aria.currentPage"),
            page: t("kf.pdp.label.aria.page"),
            breadcrumb: t("kf.pdp.label.aria.breadcrumb")
        },
        outOfStockErr: (_modalRightSectionNoStockMsg = authorData.modalRightSectionNoStockMsg) !== null && _modalRightSectionNoStockMsg !== void 0 ? _modalRightSectionNoStockMsg : t("kf.pdp.label.reqItem.err.outOfStockErrMsg"),
        removeItem: t("kf.favorites.removeItem"),
        removeItemError: t("kf.favorites.removeItemError"),
        backInStock: t("kf.pdp.label.backInStock"),
        notApplicable: t("kf.pdp.label.notApplicable"),
        partNumber: t("kf.pdp.label.partNumber"),
        partName: t("kf.pdp.label.partName"),
        descReadMore: t("kf.pdp.label.descReadMore"),
        productAccordionText: {
            features: t("kf.pdp.label.features"),
            dimensions: t("kf.pdp.label.dimensions"),
            specs: t("kf.pdp.label.specs"),
            addOnServices: t("kf.pdp.label.addOnServices"),
            technologies: t("kf.pdp.label.technology"),
            productDetails: t("kf.pdp.label.productDetails"),
            material: t("kf.pdp.label.material"),
            installation: t("kf.pdp.label.installation"),
            hydrotherapy: t("kf.pdp.label.hydrotherapy"),
            rebates: t("kf.pdp.label.rebates"),
            props65Warning: t("kf.pdp.label.props65Warning"),
            selectAll: t("kf.technical.label.selectAll"),
            download: t("kf.technical.label.download"),
            installationSupport: t("kf.pdp.label.installationSupport"),
            designFiles: t("kf.technical.label.designFiles"),
            technicalInfo: t("kf.technical.label.technicalInfo"),
            file: t("kf.technical.label.file"),
            files: t("kf.technical.label.files"),
            specsSheet: t("kf.technical.label.specsSheet"),
            guides: t("kf.technical.label.guides"),
            installVideo: t("kf.technical.label.installVideo"),
            helpfulLinks: authorData.sectionHeading ? authorData.sectionHeading : t("kf.technical.label.helpfulLinks"),
            envDeclaration: t("kf.technical.label.envDeclaration"),
            installationGuide: t("kf.technical.label.installationGuide"),
            installationVideo: t("kf.technical.label.installationVideo"),
            userGuide: t("kf.technical.label.userGuide"),
            homeOwnerGuide: t("kf.technical.label.homeOwnerGuide"),
            homeOwnerGuideWithoutSPPDF: t("kf.technical.label.homeOwnerGuideWithoutSPPDF"),
            declareLabel: t("kf.technical.label.declareLabel"),
            tearSheet: t("kf.technical.label.tearSheet"),
            quickReference: t("kf.technical.label.quickReference"),
            warranty: t("kf.technical.label.warranty"),
            serviceParts: t("kf.technical.label.serviceParts"),
            twoDplan: t("kf.technical.label.twoDplan"),
            twoDside: t("kf.technical.label.twoDside"),
            twoDfront: t("kf.technical.label.twoDfront"),
            threeDfile: t("kf.technical.label.threeDfile"),
            bimFile: t("kf.technical.label.bimFile"),
            cutoutTemplate: t("kf.technical.label.cutoutTemplate"),
            partsDiagram: t("kf.pdp.label.partsDiagram"),
            installationGuidesSubTitle: t("kf.technical.label.installationGuidesSubTitle"),
            supportSubTitle: t("kf.technical.label.supportSubTitle"),
            icon: t("kf.technical.label.icon"),
            pdf: t("kf.literature.aria.label.pdf"),
            video: t("kf.technical.label.video"),
            viewMore: t("kf.pdp.label.viewMore")
        },
        baseProduct: t("kf.pdp.label.baseProduct"),
        subTotal: t("kf.pdp.label.subTotal"),
        requiredItems: t("kf.pdp.label.requiredItems"),
        requiredItemsProduct: t("kf.pdp.label.productRequiredItem"),
        requiredItemsPrice: t("kf.pdp.label.priceRequiredItem"),
        zipCodes: t("kf.pdp.lable.zipcode"),
        ingredientsLabel: authorData.ingredientsLabel,
        productSelectStyleTitle: t("annsacks.pdpSelectYStyle.label.selectYourStyle"),
        productSelectStyleShapeLabel: t("annsacks.pdpSelectYStyle.label.shapeSizeDesign"),
        productSelectStyleColorLabel: t("kf.pdpSelectYStyle.label.styleColorLabel"),
        productSelectStyleFinishLabel: t("kf.pdp.label.finish"),
        productSelectStyleShapeTotalOptions: t("annsacks.pdpSelectYStyle.label.options"),
        productSelectStyleShapeApplyBtn: t("kf.promo.button.apply"),
        productSelectStyleModalColorTitle: t("annsacks.pdpSelectYStyle.label.colorFinish"),
        productSelectStyleModalClearAll: t("kf.plp.label.clearAll"),
        productSelectStyleShowFilter: t("annsacks.pdpSelectYStyle.label.showFilter"),
        productSelectStyleAppliedLabel: t("annsacks.pdpSelectYStyle.label.appliedLabel"),
        productSelectStyleHideFilter: t("annsacks.pdpSelectYStyle.label.hideFilter"),
        productSelectStyleDiscotinuedLabel: t("kf.pdp.label.discontinuedColor"),
        productSelectStyleDiscotinuedMsg: t("annsacks.pdpSelectYStyle.label.discontinuedMsg"),
        availableFileName: t("kf.pdp.label.download.availableFileName", {
            productBrandName
        }),
        availableFileNameForSpecification: t("kf.pdp.label.download.availableFileNameForSpecification", {
            productBrandName
        }),
        fileName: t("kf.pdp.label.download.fileName"),
        skulabel: t("annsacks.annsacksPdp.sku"),
        listlabel: t("annsacks.pdpPriceList.label.list"),
        specsSheet: t("kf.technical.label.specsSheet"),
        specification: t("annsacks.annsacksPdp.label.specification"),
        Installation: t("annsacks.annsacksPdp.label.Installation"),
        cadDrawings: t("annsacks.annsacksPdp.label.cadDrawings"),
        threeDfile: t("kf.technical.label.threeDfile"),
        twoDplan: t("kf.technical.label.twoDplan"),
        twoDfront: t("kf.technical.label.twoDfront"),
        twoDside: t("kf.technical.label.twoDside"),
        dwg: t("annsacks.annsacksPdp.label.dwg"),
        dxf: t("annsacks.annsacksPdp.label.dxf"),
        calculateFootage: t("annsacks.pdpTrimCalculator.label.calculateFootage"),
        linearFtNeeded: t("annsacks.pdpTrimCalculator.label.linearFtNeeded"),
        squareFtNeeded: t("annsacks.pdpTrimCalculator.label.squareFtNeeded"),
        overage: t("annsacks.pdpTrimCalculator.label.overage"),
        lf: t("annsacks.pdpTrimCalculator.label.LF"),
        sf: t("annsacks.pdpTrimCalculator.label.SF"),
        totalLF: t("annsacks.pdpTrimCalculator.label.totalLF"),
        totalSF: t("annsacks.pdpTrimCalculator.label.totalSF"),
        pieces: t("annsacks.pdpTrimCalculator.label.pieces"),
        boxes: t("annsacks.pdpTrimCalculator.label.boxes"),
        totalPieces: t("annsacks.pdpTrimCalculator.label.totalPieces"),
        totalBoxes: t("annsacks.pdpTrimCalculator.label.totalBoxes"),
        whatYouWillReceive: t("annsacks.pdpTrimCalculator.label.whatYouWillReceive"),
        totalCoverage: t("annsacks.pdpTrimCalculator.label.totalCoverage"),
        perEach: t("annsacks.pdpProductSummary.label.perEach"),
        perBox: t("annsacks.pdpProductSummary.label.perBox"),
        perSF: t("annsacks.pdpProductSummary.label.perSF"),
        SquareF: t("annsacks.pdpProductSummary.label.SquareF"),
        LinearF: t("annsacks.pdpProductSummary.label.LinearF"),
        perLF: t("annsacks.pdpProductSummary.label.perLF"),
        each: t("annsacks.pdpProductSummary.label.each"),
        box: t("annsacks.pdpProductSummary.label.box"),
        bucket: t("annsacks.pdpProductSummary.label.bucket"),
        by: t("annsacks.pdpProductSummary.label.by"),
        stoneTop: t("annsacks.annsacksPdp.stoneTop"),
        saleLabel: t("kf.search.label.sale"),
        newLabel: t("kf.plp.label.new"),
        exclusiveLebel: t("kf.plp.label.exclusive")
    };
    return i18n;
};
/* harmony default export */ __webpack_exports__["Z"] = (usePdpi18n);


/***/ }),

/***/ 85342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64925);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88751);
/* harmony import */ var _components_ProductDetail_v3_ProductDetailView_PDPCuratedProducts_pdpCuratedProduct_module_scss__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(18475);
/* harmony import */ var _components_ProductDetail_v3_ProductDetailView_PDPCuratedProducts_pdpCuratedProduct_module_scss__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_components_ProductDetail_v3_ProductDetailView_PDPCuratedProducts_pdpCuratedProduct_module_scss__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82476);
/* harmony import */ var _components_Shared_UpsellInstallServices_ParentProductCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72337);
/* harmony import */ var _components_Shared_UpsellInstallServices_RequiredProductItem__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97217);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18216);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20558);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85518);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27514);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19514);
/* harmony import */ var _components_Shared_UpsellInstallServices_api__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47936);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(44561);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9473);
/* harmony import */ var _components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(75179);
/* harmony import */ var _utils_addTocart__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(84003);
/* harmony import */ var _components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(59998);
/* harmony import */ var _components_sharedCart_shareCartHelper__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(88611);





















const PDPCuratedProducts = (param)=>{
    let { slug ="" , authData ={} , authData: { presetConfigs ={} , recommendationTitle ="" , selectedTitle ="" , swatchUrl: baseUrl = "" , mainTitle ="" , productTitle =""  } = {}  } = param;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_15__/* .useDispatch */ .I0)();
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const { pdp: { sku: updatedSku = ""  } = {} , pdp: PdpInfo = {}  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_15__/* .useSelector */ .v9)(_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_14__/* .selectPdpState */ .BY);
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .getUserPersona */ .shu)();
    const rowCols = (0,_utils_index__WEBPACK_IMPORTED_MODULE_8__/* .getRowCols */ .n)(width, react_device_detect__WEBPACK_IMPORTED_MODULE_9__/* .isMobile */ .tq, react_device_detect__WEBPACK_IMPORTED_MODULE_9__/* .isTablet */ .Em);
    const [parentProductData, setParentProductData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [requiredItemsProductData, setRequiredItemsProductData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [includedItems, setIncludedItems] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [brandName, setBrandName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("kohler");
    const [addToCartLoader, setAddToCartLoader] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const parsedPresetConfigs = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(presetConfigs) ? JSON.parse(presetConfigs) : {};
    const handleScroll = ()=>{
        var ref;
        const scrollpostion = (ref = document.querySelector(".pdp-curated-recommendation")) === null || ref === void 0 ? void 0 : ref.offsetTop;
        const yscrollposition = window.scrollY;
        if (yscrollposition >= scrollpostion - 300) {
            if (!window.isUpsellAnalaticsLoaded) {
                const productDataAnlytics = anylticsPdpData();
                (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_18__/* .addAnalyticsPDPWhenUpSellVisible */ .AD)(recommendationTitle, productDataAnlytics, persona);
                window.isUpsellAnalaticsLoaded = true;
            }
        }
    };
    const onScroll = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        handleScroll();
    }, [
        parentProductData,
        requiredItemsProductData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        document.addEventListener("scroll", onScroll);
        return ()=>{
            document.removeEventListener("scroll", onScroll);
        };
    }, [
        onScroll
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        window.isUpsellAnalaticsLoaded = false;
        if (updatedSku) executeInitialCalls();
    }, [
        updatedSku
    ]);
    const anylticsPdpData = ()=>{
        var ref, ref1, ref2;
        var _data;
        const parentProductDataInfo = (_data = PdpInfo.data) !== null && _data !== void 0 ? _data : [];
        const { ["Color.SKU.Details_ss"]: colors = []  } = parentProductDataInfo;
        let matchedColor = [];
        if (colors.length) {
            matchedColor = colors.filter((colorItem)=>{
                const itemLen = colorItem.split("|").length;
                return colorItem.split("|")[itemLen - 1].substring(2, colorItem.split("|")[itemLen - 1].length) === PdpInfo.sku;
            });
        }
        const parentProductDataAll = {
            desc: parentProductDataInfo === null || parentProductDataInfo === void 0 ? void 0 : parentProductDataInfo.ProductDescriptionProductShort_s,
            category: parentProductDataInfo === null || parentProductDataInfo === void 0 ? void 0 : parentProductDataInfo.ProductLocalCategory_s,
            image: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.productImageUrl,
            unitPrice: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.unitPrice,
            productPrice: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.unitPrice,
            customerFacingSKU: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.customerFacingSKU,
            productTileName: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.name,
            quantity: 1,
            name: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.name,
            color: matchedColor ? (ref = matchedColor[0]) === null || ref === void 0 ? void 0 : ref.split("|")[0] : "",
            parentglobalPromotionPrice: (ref1 = PdpInfo.data) === null || ref1 === void 0 ? void 0 : ref1["priceList.".concat(persona, ".finalPrice_d")],
            ["priceList.".concat(persona, ".discountedPrice_d")]: (ref2 = PdpInfo.data) === null || ref2 === void 0 ? void 0 : ref2["priceList.".concat(persona, ".finalPrice_d")],
            itemType: "product",
            productRoomType: parentProductDataInfo === null || parentProductDataInfo === void 0 ? void 0 : parentProductDataInfo.category1_s
        };
        const productDataForAnlytics = {
            parentProductDataAll,
            requiredItemsProductData
        };
        return productDataForAnlytics !== null && productDataForAnlytics !== void 0 ? productDataForAnlytics : {};
    };
    const executeInitialCalls = async ()=>{
        var ref;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_11__/* .getConfig */ .i)();
        const { general: { siteName ="" , lwAppName =""  } = {}  } = config !== null && config !== void 0 ? config : {};
        var ref1;
        const { data: { response: { docs: requiredItemsSku = []  } = {}  } = {}  } = (ref1 = await (0,_components_Shared_UpsellInstallServices_api__WEBPACK_IMPORTED_MODULE_12__/* .getListOfRequiredSkus */ .Q3)(persona, slug, updatedSku, lwAppName)) !== null && ref1 !== void 0 ? ref1 : {};
        if (!requiredItemsSku.length) {
            setRequiredItemsProductData([]);
            setLoading(false);
            return;
        }
        var ref2;
        const { data: { results: parentProductInventory = []  } = {}  } = (ref2 = await (0,_components_Shared_UpsellInstallServices_api__WEBPACK_IMPORTED_MODULE_12__/* .getProductInventory */ .o)(updatedSku)) !== null && ref2 !== void 0 ? ref2 : {};
        const parentProductQuantity = parentProductInventory.length ? (ref = parentProductInventory[0]) === null || ref === void 0 ? void 0 : ref.availableQuantity : 0;
        var ref3;
        const { CrossSellRecommendationSKUList_ss: requiredSkuList = [] , sku_s: sku = "" , ProductBrandName_s: productBrandName = "" , ["priceList.".concat(persona, ".price_d")]: productPrice = 0 , ["productImages.labelWithUrl_ss"]: labledImages  } = (ref3 = requiredItemsSku[0]) !== null && ref3 !== void 0 ? ref3 : {};
        if (!requiredSkuList.length) {
            setRequiredItemsProductData([]);
            setLoading(false);
            return;
        }
        let imgId = "";
        if (labledImages.length) {
            var ref4, ref5;
            const index = labledImages.map((item)=>{
                var ref;
                return ((ref = item.split("|")) === null || ref === void 0 ? void 0 : ref.length) ? item.split("|")[0] : "";
            }).indexOf(updatedSku);
            const assetId = ((ref5 = (ref4 = labledImages[index]) === null || ref4 === void 0 ? void 0 : ref4.split("|")) === null || ref5 === void 0 ? void 0 : ref5.length) ? labledImages[index].split("|")[1] : "";
            imgId = assetId;
        }
        const productImageUrl = (0,_utils_index__WEBPACK_IMPORTED_MODULE_8__/* .getPresetUrl */ .v$)(width, rowCols, baseUrl, imgId, parsedPresetConfigs);
        setParentProductData({
            customerFacingSKU: sku,
            name: productBrandName,
            unitPrice: productPrice,
            availableQuantity: parentProductQuantity,
            productImageUrl
        });
        setBrandName(siteName);
        if (requiredSkuList.length) {
            var ref6;
            const { data: { results: productInventory = []  } = {}  } = (ref6 = await (0,_components_Shared_UpsellInstallServices_api__WEBPACK_IMPORTED_MODULE_12__/* .getProductInventory */ .o)(requiredSkuList.join(","))) !== null && ref6 !== void 0 ? ref6 : {};
            var ref7;
            const { data ={}  } = (ref7 = await (0,_components_Shared_UpsellInstallServices_api__WEBPACK_IMPORTED_MODULE_12__/* .getProductDataFromSkuIds */ .fh)(persona, requiredSkuList, lwAppName)) !== null && ref7 !== void 0 ? ref7 : {};
            if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(data)) {
                const { response: { docs: requiredSkusProductData = []  } = {}  } = data;
                const requiredItemsProductData = [];
                if (requiredSkusProductData.length) {
                    requiredSkusProductData.forEach((item)=>{
                        var ref;
                        var ref1;
                        const inventoryObj = (ref1 = productInventory.find((inventoryItem)=>item.sku_s === inventoryItem.sku)) !== null && ref1 !== void 0 ? ref1 : {};
                        var ref2;
                        const colors = (ref2 = item["Color.SKU.Details_ss"]) !== null && ref2 !== void 0 ? ref2 : [];
                        let matchedColor = [];
                        if (colors.length) {
                            matchedColor = colors.filter((colorItem)=>{
                                const itemLen = colorItem.split("|").length;
                                return colorItem.split("|")[itemLen - 1].substring(2, colorItem.split("|")[itemLen - 1].length) === item.sku_s;
                            });
                        }
                        var ref3;
                        requiredItemsProductData.push({
                            availableQuantity: (ref3 = inventoryObj === null || inventoryObj === void 0 ? void 0 : inventoryObj.availableQuantity) !== null && ref3 !== void 0 ? ref3 : 0,
                            productColor: matchedColor ? (ref = matchedColor[0]) === null || ref === void 0 ? void 0 : ref.split("|")[0] : "",
                            ...item
                        });
                    });
                    setLoading(false);
                    makeDefaultSelection(requiredItemsProductData, requiredItemsSku[0], parentProductQuantity);
                    setRequiredItemsProductData(requiredItemsProductData);
                }
            }
        }
    };
    const getSubTotal = function() {
        let requiredItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", skuId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", qty = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        return requiredItems.reduce((n, param)=>{
            let { ["priceList.".concat(persona, ".discountedPrice_d")]: discountedPrice = 0 , ["priceList.".concat(persona, ".price_d")]: productPrice = 0 , sku_s: sku = "" , availableQuantity =0  } = param;
            var ref;
            let quantity = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(availableParentSku) ? (ref = availableParentSku.includedItems[sku]) === null || ref === void 0 ? void 0 : ref.quantity : 1;
            skuId && sku === skuId ? quantity = qty : quantity;
            const price = availableQuantity ? discountedPrice || productPrice : 0;
            return n + price * quantity;
        }, 0);
    };
    const makeDefaultSelection = function() {
        let productData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], masterSkuData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, parentProductQuantity = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        const includedRequiredItems = {};
        const { ["priceList.".concat(persona, ".finalPrice_d")]: productFinalPrice = 0  } = masterSkuData;
        const productPrice = parentProductQuantity > 0 ? productFinalPrice : 0;
        includedRequiredItems[updatedSku] = {
            subTotal: getSubTotal(productData, updatedSku) + productPrice,
            includedItems: {
                ...productData.reduce((obj, cur)=>({
                        ...obj,
                        [cur.sku_s]: {
                            check: cur.availableQuantity > 0,
                            quantity: 1,
                            availableQuantity: cur.availableQuantity
                        }
                    }), {})
            },
            check: parentProductQuantity > 0
        };
        setIncludedItems(includedRequiredItems);
    };
    const checkChangeHandlerForParentProduct = function() {
        let checked = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        var ref, ref, ref;
        const { unitPrice =0  } = parentProductData;
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        availableParentSku.check = checked;
        const operand = checked ? "+" : "-";
        const { subTotal =0  } = availableParentSku;
        availableParentSku.subTotal = eval(subTotal + operand + unitPrice);
        setIncludedItems(addedItems);
        const parentProductDataInfo = PdpInfo.data;
        const parentProductDataAll = {
            ProductDescriptionProductShort_s: parentProductDataInfo === null || parentProductDataInfo === void 0 ? void 0 : parentProductDataInfo.ProductDescriptionProductShort_s,
            Product_Category: parentProductDataInfo === null || parentProductDataInfo === void 0 ? void 0 : parentProductDataInfo.ProductLocalCategory_s,
            image: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.productImageUrl,
            unitPrice: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.unitPrice,
            customerFacingSKU: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.customerFacingSKU,
            productTileName: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.name,
            ["priceList.".concat(persona, ".finalPrice_d")]: (ref = PdpInfo.data) === null || ref === void 0 ? void 0 : ref["priceList.".concat(persona, ".finalPrice_d")],
            ["priceList.".concat(persona, ".discountedPrice_d")]: (ref = PdpInfo.data) === null || ref === void 0 ? void 0 : ref["priceList.".concat(persona, ".discountedPrice_d")],
            parentglobalPromotionPrice: (ref = PdpInfo.data) === null || ref === void 0 ? void 0 : ref["priceList.".concat(persona, ".finalPrice_d")],
            CustomerFacingBrand_s: parentProductDataInfo.CustomerFacingBrand_s,
            RegionBrandName_s: parentProductDataInfo.RegionBrandName_s,
            availableQuantity: 1,
            qty: 1,
            sku_s: parentProductData.customerFacingSKU,
            productParentImage: parentProductData.productImageUrl,
            itemType: "product",
            productRoomType: parentProductDataInfo === null || parentProductDataInfo === void 0 ? void 0 : parentProductDataInfo.category1_s
        };
        const isParent = true;
        (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_18__/* .addAnalyticsForIncludeforRequiredItem */ .bP)(checked, (authData === null || authData === void 0 ? void 0 : authData.includeTitle) ? authData === null || authData === void 0 ? void 0 : authData.includeTitle : mainTitle, recommendationTitle, parentProductDataAll, 1, requiredItemsProductData.length > 0 ? requiredItemsProductData.length - 1 : "-1", persona, isParent);
    };
    const checkChangeHandlerForReqItems = function() {
        let checked = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", skuId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(availableParentSku)) {
            availableParentSku.includedItems[skuId].check = checked;
            const checkedSkus = Object.keys(availableParentSku.includedItems).filter((key)=>{
                var ref;
                return (ref = availableParentSku.includedItems[key]) === null || ref === void 0 ? void 0 : ref.check;
            });
            const requiredFilteredItems = requiredItemsProductData.filter((item)=>checkedSkus.some((sku)=>item.sku_s === sku));
            const { unitPrice =0  } = parentProductData;
            const productPrice = availableParentSku.check ? unitPrice : 0;
            const subTotal = getSubTotal(requiredFilteredItems, parentSku);
            availableParentSku.subTotal = subTotal + productPrice;
            setIncludedItems(addedItems);
        }
    };
    const addSelectedItems = async (subTotal)=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(includedItems)) {
            setAddToCartLoader(true);
            const addedItems = {
                ...includedItems
            };
            const availableParentSku = addedItems[updatedSku];
            if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(availableParentSku)) {
                const requiredItems = availableParentSku.includedItems;
                const selectedItems = Object.keys(requiredItems).filter((key)=>requiredItems[key].check).map((item)=>{
                    var ref;
                    return {
                        sku: item,
                        quantity: (ref = requiredItems[item]) === null || ref === void 0 ? void 0 : ref.quantity
                    };
                });
                if (availableParentSku.check) {
                    var ref, ref1;
                    const itemsProjectionApiResponse = await (0,_components_sharedCart_shareCartHelper__WEBPACK_IMPORTED_MODULE_19__/* .getProductsBySku */ .uX)([
                        updatedSku
                    ]);
                    var ref2;
                    const variants = (ref2 = itemsProjectionApiResponse === null || itemsProjectionApiResponse === void 0 ? void 0 : (ref = itemsProjectionApiResponse[0]) === null || ref === void 0 ? void 0 : ref.variants) !== null && ref2 !== void 0 ? ref2 : [];
                    var ref3;
                    variants.push((ref3 = itemsProjectionApiResponse === null || itemsProjectionApiResponse === void 0 ? void 0 : (ref1 = itemsProjectionApiResponse[0]) === null || ref1 === void 0 ? void 0 : ref1.masterVariant) !== null && ref3 !== void 0 ? ref3 : {});
                    let isComboSku = false;
                    for(let i = 0; i < variants.length; i++){
                        if (updatedSku === variants[i].sku) {
                            var ref4;
                            isComboSku = ((ref4 = variants[i]) === null || ref4 === void 0 ? void 0 : ref4.attributes.find((attr)=>attr.name === "ComboSKU")) ? true : false;
                        }
                    }
                    selectedItems.push({
                        sku: updatedSku,
                        quantity: 1,
                        isBundle: isComboSku
                    });
                }
                if (selectedItems.length) {
                    const allSelectedItems = selectedItems.map((item)=>({
                            ...item,
                            brand: brandName
                        }));
                    addItemsToCart(allSelectedItems);
                    if (allSelectedItems.length) {
                        let selectedIncludePdpData = [];
                        let parentProductDataAll = [];
                        const parentProduct = allSelectedItems.filter((item)=>{
                            return item.sku === PdpInfo.sku;
                        });
                        if (parentProduct.length) {
                            var ref5;
                            var _data;
                            const parentProductDataInfo = (_data = PdpInfo.data) !== null && _data !== void 0 ? _data : [];
                            const { ["Color.SKU.Details_ss"]: colors = []  } = parentProductDataInfo;
                            let matchedColor = [];
                            if (colors.length) {
                                matchedColor = colors.filter((colorItem)=>{
                                    const itemLen = colorItem.split("|").length;
                                    return colorItem.split("|")[itemLen - 1].substring(2, colorItem.split("|")[itemLen - 1].length) === PdpInfo.sku;
                                });
                            }
                            parentProductDataAll = {
                                desc: parentProductDataInfo === null || parentProductDataInfo === void 0 ? void 0 : parentProductDataInfo.ProductDescriptionProductShort_s,
                                category: parentProductDataInfo === null || parentProductDataInfo === void 0 ? void 0 : parentProductDataInfo.ProductLocalCategory_s,
                                image: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.productImageUrl,
                                unitPrice: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.unitPrice,
                                customerFacingSKU: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.customerFacingSKU,
                                productTileName: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.name,
                                quantity: 1,
                                name: parentProductData === null || parentProductData === void 0 ? void 0 : parentProductData.name,
                                color: matchedColor ? (ref5 = matchedColor[0]) === null || ref5 === void 0 ? void 0 : ref5.split("|")[0] : ""
                            };
                        }
                        const childRecommendationProduct = allSelectedItems === null || allSelectedItems === void 0 ? void 0 : allSelectedItems.filter((item)=>item.sku !== PdpInfo.sku);
                        selectedIncludePdpData = childRecommendationProduct === null || childRecommendationProduct === void 0 ? void 0 : childRecommendationProduct.map((childItem)=>{
                            let foundIndex = -1;
                            var ref;
                            const item = (ref = requiredItemsProductData.find((requiredItem, index)=>{
                                foundIndex = index;
                                return requiredItem.sku_s === childItem.sku;
                            })) !== null && ref !== void 0 ? ref : {};
                            return {
                                ...item,
                                foundIndex
                            };
                        });
                        selectedIncludePdpData.sort((a, b)=>Number(a.foundIndex) - Number(b.foundIndex));
                        const productDataForAnlytics = {
                            parentProductDataAll,
                            selectedIncludePdpData
                        };
                        (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_18__/* .addAnalyticsForPdpAddToCart */ .P7)(subTotal, productDataForAnlytics, persona);
                    }
                }
            }
        }
    };
    const addItemsToCart = async (items)=>{
        const payload = await (0,_utils_addTocart__WEBPACK_IMPORTED_MODULE_17__/* .addToCartItem */ .q)([
            ...items
        ]);
        const body = {
            actions: payload
        };
        dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .addToCart */ .Xq)(body)).unwrap().then((res)=>{
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__/* .showPreviewCart */ .z0)());
            setAddToCartLoader(false);
            handleAddtoCartResponse(res);
        });
    };
    const handleAddtoCartResponse = (param)=>{
        let { payload  } = param;
        if (payload) {
            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .setCart */ .RV)(payload));
        }
    };
    const getSelectedItemNum = function() {
        let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const { includedItems ={} , check =false  } = item;
        let num = 0;
        for(const key in includedItems){
            if (includedItems.hasOwnProperty(key)) {
                var ref;
                if ((ref = includedItems[key]) === null || ref === void 0 ? void 0 : ref.check) num += 1;
            }
        }
        if (check) num = num + 1;
        return num;
    };
    if (!loading && requiredItemsProductData.length) {
        var ref;
        const subTotal = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(includedItems) ? (ref = includedItems[updatedSku]) === null || ref === void 0 ? void 0 : ref.subTotal : 0;
        const selectedIncludesNum = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(includedItems) ? getSelectedItemNum(includedItems[updatedSku]) : 0;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_components_ProductDetail_v3_ProductDetailView_PDPCuratedProducts_pdpCuratedProduct_module_scss__WEBPACK_IMPORTED_MODULE_20___default().pdpcuratedproductmodule),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "pdp-curated-recommendation",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pdp-curated-recommendation__title",
                        children: mainTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "pdp-curated-recommendation__conatiner",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_UpsellInstallServices_ParentProductCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                containerClassName: "-pdp-required-item",
                                checkChangeHandlerForParentProduct: checkChangeHandlerForParentProduct,
                                includedItems: includedItems,
                                productTitleUpSell: productTitle,
                                ...parentProductData,
                                ...authData
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "right-side-conatiner",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "header",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "title",
                                                children: recommendationTitle
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "button-total",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "total",
                                                        children: subTotal > 0 && subTotal != "0.00" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                            price: subTotal
                                                        }) : null
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "add-to-cart-button",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                            role: "button",
                                                            label: "Add to Cart (".concat(selectedIncludesNum, ")"),
                                                            size: "large",
                                                            type: "primary",
                                                            flexible: true,
                                                            disabled: !subTotal || subTotal === "0.00",
                                                            loading: addToCartLoader,
                                                            onClick: ()=>addSelectedItems(subTotal)
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pdp-required-modal-right-side",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "pdp-required-modal-container-list",
                                            children: requiredItemsProductData.map((item, upSellDataIndex)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_UpsellInstallServices_RequiredProductItem__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                        dynamicClass: "-pdp",
                                                        requiredProductItem: item,
                                                        persona: persona,
                                                        showQtyInput: false,
                                                        includedItems: includedItems,
                                                        parentSku: updatedSku,
                                                        updateRequiredItems: checkChangeHandlerForReqItems,
                                                        baseUrl: baseUrl,
                                                        parsedConfigs: parsedPresetConfigs,
                                                        upSellDataIndex: "0",
                                                        index: upSellDataIndex,
                                                        ...authData
                                                    })
                                                }, item.sku_s))
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "subtotal-add-to-cart--mobile",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "number-total-mobile",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "selected-mobile",
                                        children: [
                                            selectedTitle,
                                            " (",
                                            selectedIncludesNum,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "total-price",
                                        children: subTotal > 0 && subTotal != "0.00" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                            price: subTotal
                                        }) : null
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "add-to-cart-",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    role: "button",
                                    label: "Add to Cart",
                                    size: "large",
                                    type: "primary",
                                    flexible: true,
                                    loading: addToCartLoader,
                                    disabled: !subTotal || subTotal === "0.00",
                                    onClick: ()=>addSelectedItems(subTotal)
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (PDPCuratedProducts);


/***/ }),

/***/ 92762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var _components_AemGrid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3939);
/* harmony import */ var _store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44561);





const ProductExf = ()=>{
    const { teaserContent =[]  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_4__/* .selectPdpState */ .BY);
    return teaserContent.length ? teaserContent.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "exfpdp",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "xfpage",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AemGrid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    data: item,
                    count: 0
                })
            })
        }, "".concat(item["title"], "-").concat(index))) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductExf);


/***/ }),

/***/ 50023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ec": function() { return /* binding */ checkUserZipCode; },
/* harmony export */   "Jo": function() { return /* binding */ getColorFinishData; },
/* harmony export */   "O1": function() { return /* binding */ getZipCodeJsonFile; },
/* harmony export */   "S8": function() { return /* binding */ getDataSheetUrl; },
/* harmony export */   "WI": function() { return /* binding */ getColorDataObject; },
/* harmony export */   "i8": function() { return /* binding */ initPriceSpider; },
/* harmony export */   "lX": function() { return /* binding */ getTeaserFragments; },
/* harmony export */   "lk": function() { return /* binding */ getShippingLocations; },
/* harmony export */   "tz": function() { return /* binding */ checkProductCategory; },
/* harmony export */   "yS": function() { return /* binding */ getRequireItems; }
/* harmony export */ });
/* unused harmony exports getInitialSku, getTeaserDetails */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47956);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20558);
/* harmony import */ var _store_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20366);
/* harmony import */ var _store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44561);
/* harmony import */ var _components_ProductDetail_v3_analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49892);








const getInitialSku = (data)=>{
    var ref;
    const { productData , setSkuVariantCb , selectedColor  } = data;
    let colors = [];
    if (productData["Color.SKU.Details_ss"]) {
        colors = productData["Color.SKU.Details_ss"].map((color)=>{
            const d = color.split("|");
            return {
                color: d.at(0),
                sku: d[2],
                discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now())
            };
        });
    }
    const availableSkus = colors.filter((color)=>!color.discontinued);
    const discontinuedAvailableSkus = colors.filter((color)=>color.discontinued);
    let initSku = "";
    if ((ref = availableSkus[0]) === null || ref === void 0 ? void 0 : ref.sku) {
        var ref1;
        var ref2;
        const { sku: selectedColorSku = ""  } = (ref2 = availableSkus.find((el)=>el.color === selectedColor)) !== null && ref2 !== void 0 ? ref2 : {};
        var ref3;
        initSku = selectedColorSku ? selectedColorSku : (ref3 = (ref1 = availableSkus[0]) === null || ref1 === void 0 ? void 0 : ref1.sku) !== null && ref3 !== void 0 ? ref3 : productData["masterSKU_s"];
    } else {
        var ref4;
        var ref5;
        initSku = ((ref5 = (ref4 = discontinuedAvailableSkus[0]) === null || ref4 === void 0 ? void 0 : ref4.sku) !== null && ref5 !== void 0 ? ref5 : productData["variantList.sku_ss"]) ? productData["variantList.sku_ss"][0] : "";
    }
    setSkuVariantCb && setSkuVariantCb(initSku);
    return initSku;
};
const checkProductCategory = (productCategory, category)=>{
    if (productCategory === category || productCategory === "") {
        return true;
    }
    return false;
};
const getZipCodeJsonFile = (jsonFileUrl, getZipCodeJsonFileCb)=>{
    try {
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(jsonFileUrl)) {
            (0,_constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance */ .Gb)({
                url: _constants_index__WEBPACK_IMPORTED_MODULE_3__.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: jsonFileUrl
                }
            }).then((response)=>{
                if (response && response.data) {
                    getZipCodeJsonFileCb && getZipCodeJsonFileCb(response.data);
                } else {
                    console.error("API endpoint Url: Error occured while fetching data from Get URL Property");
                }
            });
        } else {
            console.warn("API endpoint Url: Get URL Property not found");
        }
    } catch (error) {
        console.error(error);
    }
};
const getShippingLocations = (statesData, states)=>{
    let resultTxt = "";
    if (statesData && (states === null || states === void 0 ? void 0 : states.length) > 0) {
        states.map((state, i)=>{
            const stateObj = statesData.find((st)=>{
                var ref;
                return state === ((ref = st.value) === null || ref === void 0 ? void 0 : ref.replace(/:US/g, ""));
            });
            if (stateObj === null || stateObj === void 0 ? void 0 : stateObj.text) {
                resultTxt = resultTxt + stateObj.text;
                if (i === states.length - 2) resultTxt += " and ";
                else if (i !== states.length - 1) resultTxt += ", ";
            }
        });
    }
    return resultTxt;
};
const getRequireItems = (items, discountedPrice, price, setInstallReqCb, setSubTotalCb, setPriceListCb, addItemsToCartCb)=>{
    setInstallReqCb(items);
    const cartItemProduct = [];
    const priceListItems = [];
    let requiredItemsPrice = 0;
    let priceLists = 0;
    let baseTotal = 0;
    let subTotalItem = 0;
    if (items.length > 0) {
        items && items.map((list)=>{
            const product = {};
            product.sku = list.skuid;
            product.brand = list.brandName;
            if (list.backorder) {
                product.quantity = 1;
                product.backorder = true;
                cartItemProduct.push(product);
            } else {
                const checkQuantity = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(list.colorsData.find((requiredItem)=>requiredItem.id === list.skuid), "isOutOfStock", false);
                product.quantity = !checkQuantity ? 1 : 0;
                if (!checkQuantity) {
                    cartItemProduct.push(product);
                }
            }
            if (list === null || list === void 0 ? void 0 : list.priceData) {
                priceLists = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(list.priceData.find((requiredList)=>requiredList.id === list.skuid), "discountedPrice", 0) > 0 ? lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(list.priceData.find((requiredList)=>requiredList.id === list.skuid), "discountedPrice", 0) : lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(list.priceData.find((requiredList)=>requiredList.id === list.skuid), "price", 0);
                priceListItems.push(priceLists);
                if (priceListItems.length >= 0) {
                    requiredItemsPrice = priceListItems.reduce((acc, item)=>{
                        return parseFloat(acc) + parseFloat(item);
                    }, 0);
                } else {
                    requiredItemsPrice = priceListItems[0];
                }
                baseTotal = discountedPrice > 0 ? discountedPrice : price;
                subTotalItem = baseTotal + requiredItemsPrice;
                setSubTotalCb(subTotalItem);
                setPriceListCb(requiredItemsPrice);
            }
        });
        addItemsToCartCb(cartItemProduct, false);
    } else {
        addItemsToCartCb([], false);
    }
};
const getTeaserFragments = (pageData, pdpData)=>{
    const teaserFragmentOrder = getFragmentsOrder(pageData);
    var ref;
    const customerFacingSKU = (ref = pdpData["masterSKU_s"]) !== null && ref !== void 0 ? ref : "";
    var ref1;
    const category = (ref1 = pdpData["ProductLocalCategory_s"]) !== null && ref1 !== void 0 ? ref1 : "";
    const pdpXFPaths = getFragmentPaths(pageData);
    if (teaserFragmentOrder && teaserFragmentOrder.length) {
        _store_index__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_6__/* .setIsTeaserLoaded */ .ZR)(true));
        const params = {
            skuId: customerFacingSKU,
            category: category
        };
        if (pdpXFPaths) params.xfPaths = pdpXFPaths;
        (0,_constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance */ .Gb)({
            url: _constants_index__WEBPACK_IMPORTED_MODULE_3__.PDP_TEASER_DETAILS,
            params
        }).then((response)=>{
            const { data  } = response;
            if (data && teaserFragmentOrder.length) getTeaserDetails(data, teaserFragmentOrder);
            else console.error("PDP Teaser Fragments Order Not Found..!");
        }).catch((error)=>{
            console.error("PDP Teaser Fragments Fetching Error..!");
        });
    }
};
const getFragmentsOrder = (pageData)=>{
    const itemOrder = [];
    const teaserFragments = (0,_utils_index__WEBPACK_IMPORTED_MODULE_4__/* .recursiveDataFunction */ .Qe)(pageData, _constants_index__WEBPACK_IMPORTED_MODULE_3__.COMPONENT_TYPES.PRODUCT_DETAILS_EXFPDP);
    if (teaserFragments && teaserFragments.length) {
        const list = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(teaserFragments[0], "configuredXfPathModels", "");
        list.map((item)=>{
            const itemArray = item && (item === null || item === void 0 ? void 0 : item.path) && item.path.split("/");
            itemOrder.push(itemArray[itemArray.length - 1]);
        });
        return itemOrder;
    }
};
const getFragmentPaths = (pageData)=>{
    const teaserFragments = (0,_utils_index__WEBPACK_IMPORTED_MODULE_4__/* .recursiveDataFunction */ .Qe)(pageData, _constants_index__WEBPACK_IMPORTED_MODULE_3__.COMPONENT_TYPES.PRODUCT_DETAILS_EXFPDP);
    if (teaserFragments && teaserFragments.length) {
        const fragmentPaths = teaserFragments.reduce((paths, fragment)=>{
            const list = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(fragment, "configuredXfPathModels", "");
            list.forEach((item)=>{
                paths.push(item === null || item === void 0 ? void 0 : item.path);
            });
            return paths;
        }, []);
        return fragmentPaths.join(",");
    }
    return "";
};
const getTeaserDetails = (data, teaserFragmentOrder)=>{
    const teaserDataPromises = [];
    teaserFragmentOrder.forEach((item)=>{
        if (data[item]) {
            teaserDataPromises.push(new Promise((resolve, reject)=>{
                (0,_constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance */ .Gb)({
                    url: _constants_index__WEBPACK_IMPORTED_MODULE_3__.GLOBAL_CONFIGURATION_ENDPOINT,
                    params: {
                        path: "".concat(data[item], ".model.json")
                    }
                }).then((res)=>{
                    resolve(res.data);
                }).catch((error)=>{
                    reject(error);
                });
            }));
        }
    });
    Promise.all(teaserDataPromises).then((response)=>{
        _store_index__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_6__/* .setTeaserContent */ .ub)(response));
    }).catch((error)=>{
        _store_index__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_6__/* .setTeaserContent */ .ub)([]));
        console.error("PDP Teaser Fragments Data Fetching Error..!");
    });
};
const initPriceSpider = ()=>{
    const waitTimeForPsWidgetElementsToLoad = 500;
    let psWidgetNode = document.getElementsByClassName("ps-widget")[0];
    // Here reason to use mutation observer instead of react ref is bcoz
    // this ps widget elements are getting fluctuated
    const psWidgetObserver = new MutationObserver(()=>{
        // fired when a mutation occurs
        psWidgetNode.querySelectorAll("div[data-retailer]").forEach((retailerDiv)=>{
            var ref;
            const btn = retailerDiv.querySelector(".ps-online-buy-button");
            const retailer = (ref = retailerDiv.getAttribute("data-retailer")) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            if (btn.getAttribute("attachedEvent") !== "true") {
                btn.addEventListener("click", (e)=>{
                    (0,_components_ProductDetail_v3_analytics__WEBPACK_IMPORTED_MODULE_7__/* .addBuyBtnAnalytics */ .f8)(e, retailer);
                }, false);
                btn.setAttribute("attachedEvent", "true");
            }
        });
    });
    let psWidgetObserverTimeout;
    const addObserverIfDesiredNodeAvailable = ()=>{
        psWidgetNode = document.getElementsByClassName("ps-widget")[0];
        if (!psWidgetNode) {
            psWidgetObserverTimeout = setTimeout(addObserverIfDesiredNodeAvailable, waitTimeForPsWidgetElementsToLoad);
            return;
        }
        if (psWidgetObserverTimeout) {
            clearTimeout(psWidgetObserverTimeout);
            psWidgetObserverTimeout = undefined;
        }
        const config = {
            subtree: true,
            childList: true
        };
        psWidgetObserver.observe(psWidgetNode, config);
    };
    addObserverIfDesiredNodeAvailable();
};
const getDataSheetUrl = function() {
    let productServices = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], currentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var ref;
    const currentSkuMasterVariant = (ref = productServices.find((product)=>{
        var ref;
        return (product === null || product === void 0 ? void 0 : (ref = product.masterVariant) === null || ref === void 0 ? void 0 : ref.sku) === currentSku;
    })) !== null && ref !== void 0 ? ref : {};
    const { masterVariant: { attributes =[]  } = {}  } = currentSkuMasterVariant;
    var ref1;
    const { value: productResourceData = []  } = (ref1 = attributes.find((e)=>e.name === "ProductResource")) !== null && ref1 !== void 0 ? ref1 : {};
    var ref2;
    const dataSheet = (ref2 = productResourceData.find((e)=>{
        return e.find((el)=>el.value === "DataSheet");
    })) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3;
    const { value: resourceFullWebURL = ""  } = (ref3 = dataSheet.find((e)=>e.name === "ResourceFullWebURL")) !== null && ref3 !== void 0 ? ref3 : {};
    return resourceFullWebURL;
};
const getColorDataObject = (d)=>{
    return {
        name: d[0],
        swatch: d[1],
        sku: d[2],
        isStock: d[3],
        discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now()),
        customerSku: d[5]
    };
};
const getColorFinishData = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return data["Color.SKU.Details_ss"];
};
const checkUserZipCode = (data)=>{
    const { userZipCode , state , callBack  } = data;
    let availableSkuIdsForService = [];
    const { zipCodeData =[]  } = state;
    for (const zipKey of zipCodeData){
        const key = Object.keys(zipKey)[0];
        for (const zipInnerKey of zipKey[key]){
            const zipcode = Object.keys(zipInnerKey)[0];
            if (zipcode === userZipCode) {
                availableSkuIdsForService = zipInnerKey[zipcode];
                break;
            }
        }
        if (availableSkuIdsForService.length) break;
    }
    const isNearest = availableSkuIdsForService.length;
    callBack && callBack(isNearest);
};


/***/ }),

/***/ 87255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_Review; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
;// CONCATENATED MODULE: ./src/components/Review/v1/analytics.js

const addFirstReviewAnalyticsEvent = (productInfo)=>{
    setTimeout(()=>{
        const actualFirstReviewButton = document.getElementById("first-to-write");
        if (!window.isFirstReviewEventLoaded && actualFirstReviewButton && productInfo) {
            // this means review contents are loaded
            actualFirstReviewButton.addEventListener("click", ()=>clickEvent("be the first to review this product", productInfo));
            window.isFirstReviewEventLoaded = true;
        } else if (!window.isFirstReviewEventLoaded && (!window.reiterate || window.reiterate < 10)) {
            var _reiterate;
            window.reiterate = ((_reiterate = window.reiterate) !== null && _reiterate !== void 0 ? _reiterate : 0) + 1;
            addFirstReviewAnalyticsEvent(productInfo);
        }
    }, 2000);
};
const addWriteReviewAnalyticsEvent = (productInfo)=>{
    setTimeout(()=>{
        const actualWriteReviewButtons = document.getElementsByClassName("bv-write-review");
        if (!window.isWriteReviewEventLoaded && (actualWriteReviewButtons === null || actualWriteReviewButtons === void 0 ? void 0 : actualWriteReviewButtons.length) && productInfo) {
            const actualWriteReviewButton = actualWriteReviewButtons[0];
            // this means review contents are loaded
            actualWriteReviewButton.addEventListener("click", ()=>clickEvent("write a review", productInfo));
            window.isWriteReviewEventLoaded = true;
        } else if (!window.isWriteReviewEventLoaded && (!window.reiterate1 || window.reiterate1 < 10)) {
            var _reiterate1;
            window.reiterate1 = ((_reiterate1 = window.reiterate1) !== null && _reiterate1 !== void 0 ? _reiterate1 : 0) + 1;
            addWriteReviewAnalyticsEvent(productInfo);
        }
    }, 2000);
};
const clickEvent = (type, productInfo)=>{
    const eventInfo = getEventInfo(type);
    const productInfoA = productInfo ? JSON.parse(productInfo).productInfo : null;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo: productInfoA
    });
    (0,helper/* closeModalAnalytics */.u8D)(productInfo);
};
const getEventInfo = (type)=>{
    return {
        eventAction: "pdp:customer reviews:" + type,
        eventName: "pdp:customer reviews:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:navigation",
        internalLinkZoneName: "pdp:customer reviews",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
};

;// CONCATENATED MODULE: ./src/components/Review/v1/Review.view.jsx



const ReviewDetail = (props)=>{
    const { productInfo ={} , bazaarVoiceProductId =""  } = props;
    const reviewContainer = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        // we need to use javascript to fetch dom element as it's a third party script getting loaded(BazaarVoice) here and we don't have control over dom.
        if ((!window.isFirstReviewEventLoaded || !window.isWriteReviewEventLoaded) && bazaarVoiceProductId && productInfo && reviewContainer.current) {
            addFirstReviewAnalyticsEvent(productInfo);
            addWriteReviewAnalyticsEvent(productInfo);
        }
        return ()=>{
            delete window.isFirstReviewEventLoaded;
            delete window.isWriteReviewEventLoaded;
            delete window.reiterate1;
            delete window.reiterate;
            delete window.checker;
            delete window.modalCloseEventLoaded;
        };
    }, [
        productInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "review",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "kf-react-plp-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ml-0 mr-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "review-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        "data-bv-show": "reviews",
                        "data-bv-product-id": bazaarVoiceProductId,
                        ref: reviewContainer
                    })
                })
            })
        })
    });
};
ReviewDetail.defaultProps = {
    bazaarVoiceProductId: "",
    productInfo: {}
};
/* harmony default export */ var Review_view = (ReviewDetail);

// EXTERNAL MODULE: ./store/features/pdpSlice.js
var pdpSlice = __webpack_require__(44561);
;// CONCATENATED MODULE: ./src/components/Review/v1/Review.jsx





const Review = (props)=>{
    const { pdp: { sku ="" , variants =[]  } , productInfo ={}  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    var ref;
    const variant = (ref = variants.find((v)=>v.sku === sku)) !== null && ref !== void 0 ? ref : {};
    return sku && (variant === null || variant === void 0 ? void 0 : variant.discontinued) && productInfo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Review_view, {
        bazaarVoiceProductId: sku,
        productInfo: productInfo
    });
};
/* harmony default export */ var v1_Review = (Review);


/***/ }),

/***/ 38279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VideoWrapper_VideoWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/youtube-play.svg
/* harmony default export */ var youtube_play = ({"src":"/_next/static/media/youtube-play.fcf5eeeb.svg","height":64,"width":64});
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/YouTube.esm.js
var YouTube_esm = __webpack_require__(13913);
;// CONCATENATED MODULE: ./src/components/VideoWrapper/VideoWrapper.jsx




const waitTimeForResetingIsClick = 500;
const VideoWrapper = (props)=>{
    const { videoId ="" , thumb ="" , height ="100%" , width =0 , alt ="image" , playThumb =false , onClick =()=>{} , getVideoInfo =()=>{} , index =0 , totalPdpImages =0 , zoomEntryPoint =""  } = props;
    const addAnalyticsData = (type, event)=>{
        const { adobeDataLayer: { getState  } = {}  } = window;
        const { videoTitle ="" , title =""  } = event === null || event === void 0 ? void 0 : event.target;
        const videoName = type === "fullscreen" ? title.toLowerCase() : videoTitle.toLowerCase();
        const page = getState && getState("page") || {};
        const { imageSequence  } = props;
        const eventInfo = {
            eventAction: "pdp:product details:carousel image click:video ".concat(type),
            eventName: "pdp:product details:carousel image click:video ".concat(type),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "video ".concat(type),
            internalLinkPosition: "pdp",
            internalLinkType: "pdp:".concat(zoomEntryPoint ? zoomEntryPoint : "video navigation"),
            internalLinkZoneName: "pdp:product details".concat(totalPdpImages ? ":view gallery" : ""),
            internalLinkURL: "n/a",
            videoId,
            clickInternalLinks: "true",
            ...imageSequence && {
                imageSequence
            },
            videoName,
            imageSequence: "".concat(index, "_").concat(totalPdpImages)
        };
        const { productInfo  } = page;
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page,
            productInfo
        });
    };
    const youtubePlayerPayload = {
        height,
        width,
        videoId,
        playerVars: {
            rel: 0,
            frameBorder: 0,
            allowFullScreen: true,
            autoPlay: 1
        }
    };
    const videoFullScreenCallback = (event)=>{
        if (window.isClick === true) {
            return;
        }
        window.isClick = true;
        setTimeout(()=>{
            delete window.isClick;
        }, waitTimeForResetingIsClick);
        if (document.webkitIsFullScreen || document.mozFullScreen || document.fullScreen) {
            if (event.target.tagName === "IFRAME") {
                addAnalyticsData("fullscreen", event);
            }
        }
    };
    (0,react.useEffect)(()=>{
        document.addEventListener("fullscreenchange", videoFullScreenCallback);
        document.addEventListener("webkitfullscreenchange", videoFullScreenCallback);
    }, []);
    const onReady = (e)=>{
        getVideoInfo(e.target, index, videoId);
    };
    return thumb || playThumb ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                role: "button",
                onClick: ()=>playThumb && onClick(videoId),
                src: "https://i.ytimg.com/vi/".concat(videoId, "/").concat(playThumb ? "mqdefault" : "default", ".jpg"),
                alt: alt,
                tabIndex: 0,
                className: "img-fluid"
            }),
            playThumb && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: youtube_play === null || youtube_play === void 0 ? void 0 : youtube_play.src,
                onClick: ()=>onClick(videoId),
                className: "img-play-button",
                alt: alt
            }),
            " "
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTube_esm/* default */.Z, {
        videoId: videoId,
        opts: youtubePlayerPayload,
        onPlay: (e)=>addAnalyticsData("play", e),
        onEnd: (e)=>addAnalyticsData("complete", e),
        className: "pdp-image-reel__image-list pdp-image-reel__modal-image",
        onReady: onReady
    });
};
/* harmony default export */ var VideoWrapper_VideoWrapper = (VideoWrapper);


/***/ }),

/***/ 46760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47956);





const NextHead = (props)=>{
    var ref, ref1;
    const { title ="" , description ="" , templateName ="" , fullUrl ="" , psKey ="" , psCountry ="" , psLanguage ="" , pageUrl ="" , metaLanguage ="" , pdpData: { ProductBrandName_s: productName = "" , productName_s: partsName = "" , // ProductDescriptionProductShort_s: productDescription = "",
    "Color.SKU.Details_ss": skuDetails = [] , productIsInStock_b: available = true , masterVariantDataResponse: variants = [] , productName_s: productFullName = "" , metaDescription_s: productMetaDescription = ""  } = {} , pdpData ={} , initialImageFullUrl ="" , isPart =false , skuId ="" , siteName ="" , isBundleProduct =false , currencyCode ="USD" , persona ="GST"  } = props;
    var ref2;
    const selectedSkuDetails = (ref2 = skuDetails === null || skuDetails === void 0 ? void 0 : skuDetails.find((item)=>item.includes(skuId))) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    const selectSkuList = (ref3 = selectedSkuDetails === null || selectedSkuDetails === void 0 ? void 0 : selectedSkuDetails.split("|")) !== null && ref3 !== void 0 ? ref3 : [];
    var ref4;
    const selectedSku = (ref4 = selectSkuList[selectSkuList.length - 1]) !== null && ref4 !== void 0 ? ref4 : "";
    const [masterVariant, setMasterVariant] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [otherVariants, setOtherVariants] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    let showroomAddress = "";
    let breadCrumb = [];
    extractTeaserDescriptions(props);
    extractBreadCrumb(props);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (variants.length > 0) {
            const masterVariant = variants.filter((variant)=>variant.masterVariant_b);
            const otherVariant = variants.filter((variant)=>!variant.masterVariant_b);
            setMasterVariant(masterVariant);
            setOtherVariants(otherVariant);
        }
    }, [
        variants
    ]);
    // Recursive extractor for Find a showroom
    function extractTeaserDescriptions(data) {
        if (fullUrl.includes("/find-a-showroom/")) {
            if (Array.isArray(data)) {
                data.forEach((item)=>extractTeaserDescriptions(item));
            } else if (typeof data === "object" && data !== null) {
                if (data[":type"] === "annsacks/components/teaser_v2" && data.description) {
                    if (data.description.includes("tel:")) {
                        showroomAddress = data.description;
                        return;
                    }
                } else {
                    const itemsOrder = data[":itemsOrder"];
                    return itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((itemOrder, idx)=>{
                        const items = data[":items"][itemOrder];
                        if (showroomAddress === "") extractTeaserDescriptions(items);
                        else return;
                    });
                }
            }
        }
    }
    // Recursive extractor
    function extractBreadCrumb(data) {
        if (Array.isArray(data)) {
            data.forEach((item)=>extractBreadCrumb(item, results));
        } else if (typeof data === "object" && data !== null) {
            if (data[":type"] === "kf/components/breadcrumb/v1/breadcrumb" && Array.isArray(data["items"])) {
                breadCrumb = data["items"];
                return;
            } else {
                const itemsOrder = data[":itemsOrder"];
                return itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((itemOrder, idx)=>{
                    const items = data[":items"][itemOrder];
                    if (breadCrumb.length === 0) extractBreadCrumb(items);
                    else return;
                });
            }
        }
    }
    const getVariantImage = (variantImages, tmpSkuId)=>{
        let initialImgUrl = "";
        let initialImageFullUrl = "";
        let variantImageLabels = [];
        let variantImageURLs = [];
        if (variantImages === null || variantImages === void 0 ? void 0 : variantImages.length) {
            const selVarImageUrls = [];
            const selVarImageLabels = [];
            variantImages.forEach((img)=>{
                const imgDetail = img.split("|");
                if (tmpSkuId === imgDetail[0]) {
                    var ref;
                    selVarImageLabels.push((ref = imgDetail[4]) !== null && ref !== void 0 ? ref : "");
                    selVarImageUrls.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : _constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL);
                } else if (!variants.find((v)=>v === imgDetail[0])) {
                    var ref1;
                    variantImageLabels.push((ref1 = imgDetail[4]) !== null && ref1 !== void 0 ? ref1 : "");
                    variantImageURLs.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : _constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL);
                }
            });
            variantImageLabels = [
                ...selVarImageLabels,
                ...variantImageLabels
            ];
            variantImageURLs = [
                ...selVarImageUrls,
                ...variantImageURLs
            ];
            if (variantImageURLs.length < 1) {
                variantImageLabels.push(tmpSkuId);
                variantImageURLs.push(_constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL);
            }
        } else {
            variantImageLabels.push(tmpSkuId);
            variantImageURLs.push(_constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL);
        }
        const assetIdArray = variantImageURLs ? variantImageURLs[0].split("PAWEB/") : [
            ""
        ];
        initialImgUrl = assetIdArray.length > 1 ? assetIdArray[1] : "";
        var ref;
        initialImageFullUrl = (ref = variantImageURLs.find((image)=>image.includes(initialImgUrl))) !== null && ref !== void 0 ? ref : "";
        return initialImageFullUrl;
    };
    const getVariantsSchema = ()=>{
        let variantsSchema = [];
        if (otherVariants.length > 0) {
            variantsSchema = variants.map((variant)=>{
                var ref;
                const skuId = (ref = variant === null || variant === void 0 ? void 0 : variant.sku_s) !== null && ref !== void 0 ? ref : "";
                var ref1;
                const selectedSkuDetails = (ref1 = skuDetails === null || skuDetails === void 0 ? void 0 : skuDetails.find((item)=>item.includes(skuId))) !== null && ref1 !== void 0 ? ref1 : "";
                var ref2;
                const selectSkuList = (ref2 = selectedSkuDetails === null || selectedSkuDetails === void 0 ? void 0 : selectedSkuDetails.split("|")) !== null && ref2 !== void 0 ? ref2 : [];
                var ref3;
                const selectedSku = (ref3 = selectSkuList[selectSkuList.length - 1]) !== null && ref3 !== void 0 ? ref3 : "";
                var ref4, ref5, ref6, ref7, ref8, ref9;
                return {
                    "@type": "Product",
                    sku: selectedSku,
                    gtin: (ref4 = variant === null || variant === void 0 ? void 0 : variant.SKUUPCCode_s) !== null && ref4 !== void 0 ? ref4 : "",
                    image: getVariantImage(variant["productImages.labelWithUrl_ss"], variant.sku_s),
                    name: (ref5 = variant === null || variant === void 0 ? void 0 : variant.productName_s) !== null && ref5 !== void 0 ? ref5 : "",
                    description: (ref6 = variant === null || variant === void 0 ? void 0 : variant.metaDescription_s) !== null && ref6 !== void 0 ? ref6 : "",
                    color: (ref7 = variant === null || variant === void 0 ? void 0 : variant.ColorFinish_s) !== null && ref7 !== void 0 ? ref7 : "",
                    offers: {
                        "@type": "Offer",
                        url: "".concat(fullUrl, "?skuId=").concat((ref8 = variant === null || variant === void 0 ? void 0 : variant.sku_s) !== null && ref8 !== void 0 ? ref8 : ""),
                        priceCurrency: currencyCode || "USD",
                        price: (ref9 = variant === null || variant === void 0 ? void 0 : variant["priceList.".concat(persona, ".finalPrice_d")]) !== null && ref9 !== void 0 ? ref9 : 0,
                        itemCondition: "https://schema.org/NewCondition",
                        availability: variant.productIsInStock_b ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
                    }
                };
            });
        }
        return variantsSchema;
    };
    var ref5, ref6, ref7;
    const productSchema = otherVariants.length > 0 ? [
        {
            "@context": "https://schema.org",
            "@type": "ProductGroup",
            "@id": fullUrl,
            url: fullUrl,
            additionalType: isPart ? "Service Part" : "",
            name: isPart ? partsName : isBundleProduct ? partsName : productFullName,
            image: initialImageFullUrl,
            description: isBundleProduct ? partsName : productMetaDescription,
            sku: isBundleProduct ? skuId : selectedSku || skuId,
            gtin: (ref5 = masterVariant === null || masterVariant === void 0 ? void 0 : (ref = masterVariant[0]) === null || ref === void 0 ? void 0 : ref.SKUUPCCode_s) !== null && ref5 !== void 0 ? ref5 : "",
            brand: {
                "@type": "Brand",
                name: siteName
            },
            productGroupID: isBundleProduct ? skuId : selectedSku,
            variesBy: [
                "https://schema.org/color"
            ],
            hasVariant: getVariantsSchema()
        }
    ] : {
        "@context": "https://schema.org",
        "@type": "Product",
        "@id": fullUrl,
        url: fullUrl,
        additionalType: isPart ? "Service Part" : "",
        name: isPart ? partsName : isBundleProduct ? partsName : productFullName,
        image: initialImageFullUrl,
        description: isBundleProduct ? partsName : productMetaDescription,
        sku: isBundleProduct ? skuId : selectedSku || skuId,
        gtin: (ref6 = masterVariant === null || masterVariant === void 0 ? void 0 : (ref1 = masterVariant[0]) === null || ref1 === void 0 ? void 0 : ref1.SKUUPCCode_s) !== null && ref6 !== void 0 ? ref6 : "",
        priceCurrency: currencyCode || "USD",
        brand: {
            "@type": "Brand",
            name: siteName
        },
        offers: {
            "@type": "Offer",
            price: (ref7 = pdpData === null || pdpData === void 0 ? void 0 : pdpData["priceList.".concat(persona || "GST", ".finalPrice_d")]) !== null && ref7 !== void 0 ? ref7 : 0,
            priceCurrency: currencyCode || "USD",
            availability: available ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
            itemCondition: "http://schema.org/NewCondition"
        },
        hasVariant: getVariantsSchema()
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: "Kohler US Plumbing Bathroom Kitchen"
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: description
                    })
                ]
            }),
            pageUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: pageUrl
            }) : null,
            templateName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: templateName
            }) : null,
            metaLanguage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: metaLanguage === null || metaLanguage === void 0 ? void 0 : metaLanguage.toLocaleLowerCase()
            }) : null,
            fullUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: fullUrl
            }) : null,
            psKey ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "ps-key",
                content: psKey
            }) : null,
            psCountry ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "ps-country",
                content: psCountry
            }) : null,
            psLanguage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "ps-language",
                content: psLanguage
            }) : null,
            productName || partsName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default().sanitize(JSON.stringify(productSchema))
                }
            }, "structured-data") : null,
            showroomAddress.includes("tel:") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/showroom+json",
                dangerouslySetInnerHTML: {
                    __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default().sanitize(JSON.stringify({
                        description: showroomAddress,
                        name: title
                    }))
                }
            }, "structured-data-showroom") : null,
            (breadCrumb === null || breadCrumb === void 0 ? void 0 : breadCrumb.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/breadcrumb+json",
                dangerouslySetInnerHTML: {
                    __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default().sanitize(JSON.stringify(breadCrumb))
                }
            }, "structured-data-breadcrumb") : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NextHead);


/***/ }),

/***/ 85614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2693);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64925);
/* harmony import */ var _hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97349);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27514);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87292);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7154);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);









const usePageAuth = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .selectAuthState */ ._9);
    const { cart: activeCart , isCartLoading  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectCartState */ .xw);
    const prevToken = (0,_hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        accessToken
    });
    // just for the dev testing purpose, if works fine then can only be proceed otherwise
    // one more pr will be raised to revert the change
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        let timeoutId;
        if (!isSsr) {
            timeoutId = setTimeout(()=>{
                if (!accessToken || !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)()) {
                    dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .getOktaToken */ .cs)({
                        type: "guest"
                    }));
                }
            }, 5000);
        }
        ;
        ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        accessToken,
        isSsr
    ]);
    const callInitAuth = async ()=>{
        var ref;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
        const disableCommerce = (config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.disableCommerce) || false;
        if (disableCommerce) return;
        const hasNoActiveCart = ()=>{
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)() && accessToken && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.id) && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.cartExists);
        };
        if (hasNoActiveCart() || hasNoActiveCart() && (prevToken === null || prevToken === void 0 ? void 0 : prevToken.accessToken) !== accessToken) {
            if (!isCartLoading) {
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(true));
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)()).unwrap().then((res)=>{
                    if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)() && accessToken && (res === null || res === void 0 ? void 0 : res.cartExists) && (res === null || res === void 0 ? void 0 : res.cartExists) === "false" && (res === null || res === void 0 ? void 0 : res.error) === "No active cart exists.") {
                        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getCurrency */ .zC$)().then((currency)=>{
                            const cartPayload = {
                                currency: currency,
                                taxMode: "ExternalAmount"
                            };
                            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .createCart */ .Bk)(cartPayload)).unwrap().then(()=>{
                                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                            });
                        });
                    } else {
                        dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                    }
                });
            }
        }
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_6__/* .setCartLandingPagePath */ .NS)();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) return;
        callInitAuth();
    }, [
        accessToken,
        isSsr
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePageAuth);


/***/ }),

/***/ 18475:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pdpcuratedproductmodule":"pdpCuratedProduct_pdpcuratedproductmodule__icAUR"};

/***/ })

}]);